import React from 'react';
import PropTypes from 'prop-types';
import { FiCheck, FiX } from 'react-icons/fi';

// Nothing on this screen saves as you type — a half-typed API key written to the
// database is an outage — so the pending set gets its own persistent bar with
// the keys named, rather than a count you have to take on faith.
const UnsavedBar = ({ keys, onSave, onDiscard, saving }) => {
  const count = keys.length;
  const preview = keys.slice(0, 3).join(', ');

  return (
    <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-z-50 tw-pointer-events-none">
      <div className="tw-mx-auto tw-max-w-3xl tw-mb-5 tw-px-5 tw-pointer-events-auto">
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-bg-slate-900 tw-rounded-xl tw-px-4 tw-py-2.5 tw-shadow-xl">
          <div className="tw-min-w-0">
            <p className="tw-text-[13px] tw-font-semibold tw-text-white tw-mb-0">
              {count} unsaved change{count !== 1 ? 's' : ''}
            </p>
            <p className="tw-text-[11px] tw-text-slate-400 tw-mb-0 tw-truncate tw-font-mono">
              {preview}{count > 3 ? ` +${count - 3} more` : ''}
            </p>
          </div>

          <div className="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
            <button
              type="button"
              onClick={onDiscard}
              disabled={saving}
              className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-[12px] tw-font-medium tw-text-slate-300 tw-rounded-lg hover:tw-bg-slate-800 hover:tw-text-white tw-bg-transparent tw-cursor-pointer tw-border-0 tw-transition-colors disabled:tw-opacity-50"
            >
              <FiX size={12} /> Discard
            </button>
            <button
              type="button"
              onClick={onSave}
              disabled={saving}
              className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3.5 tw-py-1.5 tw-text-[12px] tw-font-semibold tw-text-white tw-bg-primary-600 tw-rounded-lg hover:tw-bg-primary-500 tw-cursor-pointer tw-border-0 tw-transition-colors disabled:tw-opacity-60"
            >
              {saving
                ? <span className="tw-w-3 tw-h-3 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin" />
                : <FiCheck size={12} />}
              {saving ? 'Saving…' : 'Save changes'}
              <kbd className="tw-hidden sm:tw-inline tw-text-[10px] tw-font-sans tw-text-white/60 tw-border tw-border-white/25 tw-rounded tw-px-1">⌘S</kbd>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

UnsavedBar.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSave: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

export default UnsavedBar;
